import { stringify } from 'qs'

import { useCustomSWRInfinite } from 'utils/hooks/fetchers'

export const useInfiniteVenders = (props, swrOptions) => {
  const getVendersKey = (opts) => (pageIndex, previousPageData) => {
    const propsObject = typeof opts === 'function' ? opts() : opts
    if (propsObject === null) {
      return null
    }
    if (previousPageData && !previousPageData.length) {
      return null
    }
    const limit = propsObject.limit || 30
    const params = {
      ...propsObject,
      limit: limit,
      skip: pageIndex * limit,
      isFilterListVisible: true,
    }
    return `/venders?${stringify(params)}`
  }
  const { data, ...rest } = useCustomSWRInfinite(
    getVendersKey(props),
    swrOptions
  )
  // data會無預期出現數字，不確定為什麼，
  // 先避免直接回傳錯誤的資料類型
  return { data: typeof data === 'number' ? [] : data, ...rest }
}
